import { bugNotif } from "../../api/bugsnag";
import { getErrorMsg } from "../../../Common/utils/common";

declare const _tfa: Array<{
  notify: string;
  name: string;
  id: number;
  revenue?: string;
}>;

const TABOOLA_PIXEL_ID = 1963998;

export const trackTaboolaViewContent = async (): Promise<void> => {
  try {
    if (typeof window === "undefined" || typeof _tfa === "undefined") {
      return;
    }

    _tfa.push({
      notify: "event",
      name: "view_content",
      id: TABOOLA_PIXEL_ID,
    });
  } catch (error) {
    console.log("error trackTaboolaViewContent", error);
    bugNotif("trackTaboolaViewContent", getErrorMsg(error).rawErrorMsg);
  }
};

export const trackTaboolaAddToCart = async (
  revenue?: number
): Promise<void> => {
  try {
    if (typeof window === "undefined" || typeof _tfa === "undefined") {
      return;
    }

    _tfa.push({
      notify: "event",
      name: "add_to_cart",
      id: TABOOLA_PIXEL_ID,
      ...(revenue !== undefined && { revenue: revenue.toString() }),
    });
  } catch (error) {
    console.log("error trackTaboolaAddToCart", error);
    bugNotif("trackTaboolaAddToCart", getErrorMsg(error).rawErrorMsg);
  }
};

export const trackTaboolaStartCheckout = async (
  revenue?: number
): Promise<void> => {
  try {
    if (typeof window === "undefined" || typeof _tfa === "undefined") {
      return;
    }

    _tfa.push({
      notify: "event",
      name: "start_checkout",
      id: TABOOLA_PIXEL_ID,
      ...(revenue !== undefined && { revenue: revenue.toString() }),
    });
  } catch (error) {
    console.log("error trackTaboolaStartCheckout", error);
    bugNotif("trackTaboolaStartCheckout", getErrorMsg(error).rawErrorMsg);
  }
};

export const trackTaboolaCompleteRegistration = async (
  revenue?: number
): Promise<void> => {
  try {
    if (typeof window === "undefined" || typeof _tfa === "undefined") {
      return;
    }

    _tfa.push({
      notify: "event",
      name: "complete_registration",
      id: TABOOLA_PIXEL_ID,
      ...(revenue !== undefined && { revenue: revenue.toString() }),
    });
  } catch (error) {
    console.log("error trackTaboolaCompleteRegistration", error);
    bugNotif(
      "trackTaboolaCompleteRegistration",
      getErrorMsg(error).rawErrorMsg
    );
  }
};
